

import {Component, EventEmitter, Input, OnInit, Output, ViewContainerRef} from '@angular/core';
import {Dialog} from "../../../../../../shared/dialog/dialog";
import {ApiAdminAllowedSenderDomainsService} from "../../../../../../services/api/admin/admin-allowed-sender-domains-api/admin-allowed-sender-domains-api.service";

@Component({
  selector: 'app-admin-allowed-sender-domains-create-edit-dialog',
  templateUrl: './admin-allowed-sender-domains-create-edit-dialog.component.html'
})

export class AdminAllowedSenderDomainsComponentDialog implements Dialog {

  @Input() data;
  @Output() remove = new EventEmitter<any>();

  isLoading = true;
  loadedId = null;

  loadedData;

  constructor(
    private apiAdminAllowedSenderDomainsService: ApiAdminAllowedSenderDomainsService
  ) {}


  ngOnInit(): void {
    if(this.data !== null){
      this.loadedId = this.data;
      this.getData();
    } else {

      // Load Default Data
      this.loadedData = {
        Name: ''
      }

      this.isLoading = false;

    }
  }

  getData(){
    this.isLoading = true;
    this.apiAdminAllowedSenderDomainsService.get(this.loadedId).then(response => {
      this.loadedData = response;
      this.isLoading = false;
    })
  }

  close(){
    this.remove.emit(null);
  }

  save(){
    if(this.loadedId){
      this.apiAdminAllowedSenderDomainsService.update(this.loadedId, this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    } else {
      this.apiAdminAllowedSenderDomainsService.create(this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    }

  }
}
